import Weather from './components/weather';

function App() {
	return <Weather />;
}

export default App;